// Imports an instance axios with all defaults and interceptors setup.
import axios from 'axios';
import response from './Response';
export default class Resource {
	
	constructor(options = {}){
		let {
			baseUrl = "",
			route = "",
			version = "v1",
			routeParams = {},
			query = {},
			data = {}
		} = options;
		
		this.setBaseUrl( baseUrl );
		this.setVersion( version );
		this.setRoute( route );
		this.setRouteParams( routeParams );
		this.setQuery( query );
		this.setData( data );
		this._toggleOffIsLoading();
		this._setResponse( new response() );
		
	}


	setBaseUrl( url ){
		this._baseUrl = url;
	}
	getBaseUrl(){
		return this._baseUrl;
	}


	setVersion( version ){
		this._version = version;
	}
	getVersion(){
		return this._version;
	}


	setRouteParams( routeParams ){
		this._routeParams = routeParams;
	}
	getRouteParams(){
		return this._routeParams;
	}

	
	setRoute( route ){
		this._route = route;
	}
	getRoute(){
		return this._route;
	}


	setQuery( query ){
		this._query = query;
	}
	getQuery(){
		return this._query;
	}


	setData( data ){
		this._data = data;
	}
	getData(){
		return this._data;
	}


	getResponseData(){
		return !!this.getResponse().data.data ? this.getResponse().data.data : "";
	}
	getResponseError(){
		return this.getResponse().data.hasOwnProperty("error") ? this.getResponse().data.error : "";
	}
	getResponseMessages(){
		return !!this.getResponse().data.messages ? this.getResponse().data.messages : "";
	}
	getResponse(){
		return this._response.getResponse();
	}
	_setResponse(response){
		this._response = response;
	}


	_toggleOffIsLoading(){
		this._isLoading = false;
	}
	_toggleOnIsLoading(){
		this._isLoading = true;
	}
	_toggleIsLoading(){
		this._isLoading = !this._isLoading;
	}
	isLoading(){
		return this._isLoading;
	}

	_getResource(){
		let route = this.getRoute();
		let params = this.getRouteParams();

		for( let key in params ){
			route = route.replace(`:${key}`, params[key]);
		}
		return route;
	}

	_getRequestUrl(){
		let requestUrl = this.getBaseUrl();
		
		if( this.getVersion().length > 0 ){
			requestUrl += this.getVersion() + '/';
		} 
		
		requestUrl += this._getResource();

		return requestUrl;
	}

	request( method = "get" ){
		let _this = this;
		let test = new Error().stack.toString().replace("\n"," ");
		
		this._toggleOnIsLoading();
		let params = this.getRouteParams();
		let fullRoute = true;
		/* Make sure our route is fully defined  */
		for( let key in params ){
			fullRoute = fullRoute && params[key].toString().length > 0;
		}

		if(fullRoute){
			let _RequestPromise = axios.request({
				url: this._getRequestUrl(),
				method: method,
				params: this.getQuery(),
				data: this.getData()
			});
			
			_RequestPromise.then( response => {
				this._response.setResponse(response);
				_this._toggleOffIsLoading();
			})
			.catch( error => {
				this._response.setResponse(response);

				_this._toggleOffIsLoading();

				let _data = {
					message: test,
					error: error.toJSON()
				};
				let requestUrl = this.getBaseUrl();

				if( this.getVersion().length > 0 ){
					requestUrl += this.getVersion() + '/';
				} 
				/* build info for logging and send */
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					_data.data = error.response.data;
					_data.status = error.response.status;
					_data.headers = error.response.headers;
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					_data.request = error.response.request;
				} else {
					// Something happened in setting up the request that triggered an Error
					_data.ErrorMessage = error.message;
				}
				/* output to console as error */
				console.error(_data);
				/* if 500 its server error send to logs - dont need anymore
				if(error.message.indexOf("status code 500") > -1){
					axios.request({
						url: requestUrl + "errors",
						method: "POST",
						params: this.getQuery(),
						data: _data
					});
				}
				*/
				
			});
	
			return _RequestPromise;
		}
		
	}

}
